import { FormsModule }   from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { EventLogComponent } from './event.log.component';
import { EventLogDetailComponent } from './event.log.detail/event.log.detail.component';
import { SharedModule } from '../shared/shared.module';
import { BzTabModule } from '../shared/components/tab/tab.module';
import { EventLogMenuComponent } from './event.log.menu/event.log.menu.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { EventLogStateService } from 'app/event-log/core/services/event-log.state.service';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './i18n/', '.json');
  }

@NgModule({
    imports: [
        TranslateModule.forChild({
            loader: {
              provide: TranslateLoader,
              useFactory: HttpLoaderFactory,
              deps: [HttpClient]
            }
          }),
        FormsModule,
        BrowserModule,
        SharedModule,
        BzTabModule,
        BsDatepickerModule.forRoot()
        ],
    declarations : [
        EventLogComponent,
        EventLogDetailComponent,
        EventLogMenuComponent,
        ],
    providers:[
        EventLogStateService
    ],
    exports: [
        EventLogComponent,
        EventLogMenuComponent
        ],
})
export class EventLogModule{

}
